import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cancellationrequested',
  templateUrl: './cancellationrequested.component.html',
  styleUrls: ['./cancellationrequested.component.scss']
})
export class CancellationrequestedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
